import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { Plan, PlanType } from "@/commons/services/Plans";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * プラン変更依頼 API 操作クラス
 */
export default class PlanRequests {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET PlanRequests
   */
  public async get(userStore: LoginUser): Promise<PlanRequestResponse> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.PlanRequests, formatParams);
    const response = await this.commonService.executeGet<PlanRequestResponse>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * POST PlanRequests
   */
  public async post(userStore: LoginUser, requestBody: { userId: string; requestPlanType: PlanType; requestPlan: Plan }): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.PlanRequests, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

/**
 * ### プラン更新依頼
 */
export interface PlanRequestResponse {
  /** 施設ID */
  facilityId: number;
  /** 現在プラン種別 */
  currentPlanType: PlanType;
  /** 現在プラン */
  currentPlan: Plan;
  /** 変更後プラン種別 */
  requestPlanType: PlanType;
  /** 現在プラン */
  requestPlan: Plan;
  /** 申し込み日 */
  requestDatetime: number;
  /** 適用日 */
  applyDatetime: number;
  /** 申込みユーザーID */
  userId: string;
}
